import React, { useState, useEffect } from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import {
    Text, View, StyleSheet, TouchableOpacity, Image, KeyboardAvoidingView, Keyboard, ScrollView, Pressable
} from 'react-native';
import { Avatar } from 'react-native-elements';
import { store } from "../../store/store";
import AppStyles from "../../AppStyles";
import AppTheme from "../../AppTheme";
import { doPost } from '../../utils/services/api/API';
import { AppVersionCode, IndiaRupee, ServiceName } from '../../utils/constants/AppConstants';
import { updateReduxEConsultInfo, updateSelectedAayucard } from '../../utils/services/redux/commonRedux';
import * as CommonUtils from "../../utils/services/CommonUtils";
import * as AlertService from "../../utils/services/AlertLoaderService";
import * as ScreenShimmer from "../shimmer-component/ScreenShimmer";
import { fbqEventName } from '../../utils/constants/fbqEventName';
import { AayuCardDesign } from '../../utils/widgets/AayuCard/AayuCardDesign';
import Modal from 'react-native-modal';
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import { CacheDataToRefresh, paymentServiceNameSubscription } from "../../utils/services/subject-behaviour/CommonRxjsService";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { pwaGUID } from '../CommonService';
import OmsStyles from '../../OmsStyle';
import { surveyEventName } from '../../utils/constants/ConstantsMapping';
import TextStyle from '../../TextStyle';
import { aayuCardPaymentbackSurveyList, consultationPaymentSurveyList } from '../../utils/constants/BottomSheetSurveyContent';
import { windowGTagEvent } from '../../utils/services/webapp-services/windowsInternalFunction';
import ToastModal from '../../utils/modals/ToastModal';
import { getToastContent } from '../../utils/constants/ToastContentMapping';
import RefreshCacheAction from '../../utils/services/webapp-services/RefreshCache';
import { checkCaseCodeLength, getCategoryImageNetworkURL } from '../../utils/services/econsult/EConsultUtils';
import SingleOptionSelectionBottomSheet from '../../utils/modals/SingleOptionSelectionBottomSheet';
import { getSelectedChemistStoreId } from '../../utils/services/chemist/ChemistStoreUtils';

const ServicePayment = (props) => {

    const reduxState = store.getState();

    const [omsOffers, setOmsOffers] = useState(false)
    const [showPromoNotApplicableMessg, setShowPromoNotApplicableMessg] = useState(false);

    const [serviceData, setServiceData] = useState({
        data: props.route.params?.serviceParams,
        userId: isConsultationService(props?.route?.params?.serviceName) ?
            props.route.params.serviceParams.memberId : reduxState.userDetails['id']
    });
    const [servicePricingData, updateServicePricing] = useState({
        servicePricing: {},
        serviceToken: ''
    });
    const [couponPopUp, updateCouponPopUp] = useState({
        showPopup: false,
        couponCode: '',
        titleString: '',
        subTitle: '',
        valid: false
    });
    const [couponText, updateCouponText] = useState('');
    const [isValidService, updateServiceValidity] = useState(true);
    const [serviceType, updateServiceType] = useState({
        serviceName: props.route.params?.serviceName,
        title: 'Payment Details',
        payVia: 'direct'
    })

    const [screen, updateScreenState] = useState({
        loader: true,
        // showPopup: false,
        // popupTitle: '',
        // fromPreviousScreen: true
    });

    const [toastData, setToastData] = useState({
        showToast: false, text: ''
    })

    const [render, updateRender] = useState(false);

    const [selectedEConsultAayuCard, updateSelectedEConsultAayuCard] = useState({});

    const [surveyBottomSheet, setSurveyBottomSheet] = useState(false)

    var staticData: { [x: string]: any; };
    global.allowCloseLoaderOnApiSuccess = false;

    useEffect(() => {
        paymentServiceNameSubscription.setPaymentServiceName({
            serviceName: props.route.params?.serviceName,
            consultationId: props?.route?.params?.serviceParams?.consultationId
        })
        getPaymentOffersAndModes();
    }, [])

    var premiumAayuCard = {
        consultations: 25,
        discountedPrice: 1249,
        originalPrice: 5000,
        plan: "aayu_plan_1249",
        planDisplayName: "25 E-Consultations",
        validity: 365
    };

    function isConsultationService(serviceName) {
        if (serviceName == 'Remote Consultation') return true;
        else if (serviceName == 'Aayu Card Subscription') return false;
        else updateServiceValidity(false);
        return null;
    }

    function getPaymentOffersAndModes() {
        updateScreenState({ loader: true })
        const param = {
            pwa: true, 'appVersionCode': 900, 'locale': 'en',
            'serviceName': serviceType.serviceName,
        }
        doPost('v2207/payment/list_payment_offers_and_modes', param).then(
            (response: any) => {
                if (response) {
                    setOmsOffers(response['offers']);
                    global.paymentModesList = response['paymentModes'];
                    localStorage.setItem('paymentModesList', JSON.stringify(response['paymentModes']))
                    updateScreenState({ loader: false })
                }
            })
    }


    function checkPayVia(payVia) {
        if (payVia == 'direct') return true;
        else if (payVia == 'aayu') return false;
        else updateServiceValidity(false);
        return null;
    }

    function checkSelectedAayuCardData() {
        var payVia = 'direct';
        var response = reduxState.selectedAayucard;
        if (response != null && Object.keys(response).length != 0) {
            payVia = 'aayu';
            updateServiceType({
                serviceName: props.route.params?.serviceName,
                payVia: 'aayu',
                title: 'Aayu Card Payment'
            });
        } else updateServiceType({
            serviceName: props.route.params?.serviceName,
            payVia: 'direct',
            title: isConsultationService(props?.route?.params?.serviceName) ?
                'Payment Details' : 'Aayu Card Payment'
        });
        updateSelectedEConsultAayuCard(response);
        setServiceParams('', payVia);
    }

    function getSalesPrice(servicePricing) {
        return servicePricing.totalCost
    }
    function getWalletUsableBalance(servicePricing) {
        return servicePricing.usableBalance > servicePricing.payableAmount ?
            servicePricing.payableAmount : servicePricing.usableBalance
    }
    function getSehatSikke(servicePricing) {
        return servicePricing.maxAllowedBonus
    }
    function getDiscountPrice(servicePricing) {
        return servicePricing.discount
    }
    function getEConsultSavingPrice(servicePricing) {
        return servicePricing.discount + servicePricing.maxAllowedBonus
    }
    function getAayuSavingPrice(servicePricing) {
        return servicePricing.originalPrice - servicePricing.totalCost + servicePricing.maxAllowedBonus + servicePricing.discount
    }
    function getTotalSavings(servicePricing) {
        return checkPayVia(serviceType.payVia) && isConsultationService(serviceType.serviceName) ?
            getEConsultSavingPrice(servicePricing) :
            getAayuSavingPrice(servicePricing)
    }
    function getTotalPay(servicePricing) {
        const toPay = servicePricing.payableAmount - servicePricing.usableBalance;
        return toPay > 0 ? toPay : 0
    }

    function getCircularIcon(iconName) {
        return <View style={{ marginLeft: 6, padding: 2, borderRadius: 20, borderWidth: 1, borderColor: AppTheme.color.white }}>
            <MaterialIcons name={iconName} size={10} /></View>
    }

    function setEConsultAayuCardParams(isDirect) {
        if (isDirect) {
            props.navigation.navigate(ScreenRoute.choose_acs_plan, {
                serviceParams: props.route.params.serviceParams,
                serviceName: 'Aayu Card Subscription',
                onBackPressRoute: ScreenRoute.tab_controller_screen
            });
        } else {
            updateServiceType({
                serviceName: ServiceName.consultation,
                payVia: 'direct',
                title: 'Payment Details'
            });
            setServiceParams();
            updateSelectedAayucard({});
            updateSelectedEConsultAayuCard({});
        }
    }

    function setServiceParams(couponCodeText = '', payVia = serviceType.payVia) {
        setShowPromoNotApplicableMessg(false);
        updateScreenState({ loader: true });
        const reduxState = store.getState();
        const consultationData = props?.route?.params?.serviceParams;
        const selectedAayuCardData = reduxState.selectedAayucard;
        const serviceName = props?.route?.params?.serviceName;
        // const sName = 'Aayu Card Subscription';
        const isConsultation = isConsultationService(serviceName);
        const id = reduxState.userDetails['id']
        var params = {
            appVersionCode: AppVersionCode,
            couponCode: couponCodeText,
            serviceName: getPaymentServiceName(serviceName, payVia),
            appGUID: pwaGUID()
        };
        if (isConsultation) {
            params['userId'] = consultationData.memberId;
            params['econsultParams'] = {
                consultationId: consultationData.consultationId,
                userId: consultationData.memberId
            }
            if (!checkPayVia(payVia)) {
                params['acsParams'] = {
                    plan: selectedAayuCardData ? selectedAayuCardData['plan'] : premiumAayuCard.plan,
                    userId: id
                };
            }
        } else {
            params['userId'] = id;
            params['acsParams'] = {
                plan: consultationData?.plan,
                userId: id
            };
        }
        getServiceCharge(params);
    }

    function getServiceCharge(params) {
        doPost('payment/get_service_charges', params).then(
            (response: any) => {
                if (response) {
                    updateServicePricing({
                        servicePricing: response.servicePricing,
                        serviceToken: response.serviceTokenV2
                    });
                    const isCouponValid = response.servicePricing.discount > 0;
                    const couponCode = response?.servicePricing?.couponCode;

                    if (response?.servicePricing['ugCouponCode'].length > 0 &&
                        response?.servicePricing['couponApplied'] == false) {
                        setShowPromoNotApplicableMessg(true);
                    } else {
                        setShowPromoNotApplicableMessg(false);
                    }

                    if (isCouponValid) {

                        if (isConsultationService(serviceType.serviceName))
                            MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.consultation_coupon_applied);
                        else MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_coupon_applied);

                        setTimeout(() => { setCouponPopup({ showPopup: false }) }, 4000)

                        setCouponPopup({
                            showPopup: isCouponValid,
                            couponCode: '"' + couponCode + '"',
                            titleString: isCouponValid ? 'Applied' : 'Invalid',
                            subTitle: 'You saved ' + IndiaRupee + response?.servicePricing?.discount,
                            valid: isCouponValid
                        })

                        updateCouponText(response?.servicePricing?.couponCode)

                    }
                    updateRender(true);
                    updateScreenState({ loader: false });
                } else {
                    updateScreenState({ loader: false });
                    props.navigation.pop();
                }
            }, (error: any) => {
                updateScreenState({ loader: false });
                props.navigation.pop();
            }
        )
    }


    function submitPaymentCancellationReason(selectedReason, description) {
        updateScreenState({ loader: true })
        var params = {};
        params = {
            reason: selectedReason,
            consultationId: props?.route?.params?.serviceParams?.consultationId,
            eventName: isConsultationService(serviceType.serviceName) ?
                surveyEventName.eConsultPaymentCancelled :
                surveyEventName.aayuCardPaymentCancelled
        }
        doPost('misc/payment_cancellation_survey', params).then(
            (response: any) => {
                updateScreenState({ loader: false })
                props?.navigation?.popToTop()
                props?.navigation.navigate(ScreenRoute.dashboard_screen);
            }, (error: any) => {
                updateScreenState({ loader: false })
                props?.navigation?.popToTop()
                props?.navigation.navigate(ScreenRoute.dashboard_screen);
            }
        )
    }

    function getPaymentServiceName(serviceName, payVia) {
        if (isConsultationService(serviceName))
            if (checkPayVia(payVia))
                return serviceName;
            else return serviceName.ACS;
        else return serviceName;
    }

    function updateFBQData(eventType) {
        const propsData = props.route.params.serviceParams;
        var eventName = '';
        var eventParams = {
            topay: getTotalPay(servicePricingData.servicePricing),
            walletBalance: getWalletUsableBalance(servicePricingData.servicePricing)
        }
        if (isConsultationService(serviceType.serviceName)) {
            eventName = fbqEventName[eventType]['remote'];
            eventParams['caseCode'] = propsData.caseCode;
            eventParams['plan_id'] = checkPayVia(serviceType.payVia) ? '-1' : selectedEConsultAayuCard ? selectedEConsultAayuCard['plan'] : premiumAayuCard['plan']
        } else {
            eventName = fbqEventName[eventType]['aayucard'];
            eventParams['plan_id'] = serviceData.data['plan'];
        }
        CommonUtils.triggerFBQ(eventName, eventParams);
    }

    function updateEConsultInfo() {
        const payVia = serviceType.payVia, propsData = props.route.params.serviceParams,
            servicePricing = servicePricingData.servicePricing
        updateReduxEConsultInfo({
            memberName: propsData.memberName,
            caseCode: propsData.caseCode,
            consultationId: propsData.consultationId,
            consultationHashcode: propsData.consultationHashcode,
            phoneNumber: propsData.phoneNumber,
            aayuPlanID: checkPayVia(payVia) ? '-1' : selectedEConsultAayuCard ? selectedEConsultAayuCard['plan'] : premiumAayuCard['plan'],
            toPay: getTotalPay(servicePricing),
            walletBalance: getWalletUsableBalance(servicePricing),
        })
    }

    function checkPaymentMode() {
        const serviceName = serviceType.serviceName;
        const payVia = serviceType.payVia;

        // startWalletRecharge(getTotalPay(servicePricingData.servicePricing))
        if (getTotalPay(servicePricingData.servicePricing) != 0) {
            setTimeout(() => {
                (global.paymentModesList && global.paymentModesList.length > 0) ? props.navigation.navigate(ScreenRoute.custom_checkout,
                    { serviceName: serviceName, serviceTokenV2: servicePricingData.serviceToken, serviceCharges: servicePricingData.servicePricing, onPaymentSuccessFromCustomCheckout: onPaymentSuccessFromCustomCheckout }) : null
            }, 50)
        } else {
            isConsultationService(serviceName) && checkPayVia(payVia) ?
                startEConsultWalletPayment(serviceData.userId, servicePricingData.serviceToken) :
                startAayuCardwalletPayment(serviceData.userId, servicePricingData.serviceToken);
        }
    }

    function onPaymentSuccessFromCustomCheckout(paymentSuccess) {

        if (paymentSuccess) {
            if (isConsultationService(serviceType.serviceName) === false) {
                MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_purchased)
            }

            updateFBQData('completion');
            // TODO: handle post payment redirection.
            if (isConsultationService(serviceType.serviceName)) {
                // props.navigation.popToTop();
                // global.navigateFrom = NavigateFrom.econsult_success
                // props.navigation.replace(ScreenRoute.dashboard);
                props.navigation.navigate(ScreenRoute.econsult_success);
                windowGTagEvent({ 'send_to': 'AW-713052563/TxuvCPag6OMCEJOjgdQC', 'transaction_id': '' })
            } else {
                const reduxState = store.getState();
                let refreshList = [{
                    name: RefreshCacheAction.refreshUserProfileData,
                    requestData: { pharmacyId: getSelectedChemistStoreId(reduxState) }
                }]
                CacheDataToRefresh.setRefreshList(refreshList)
                props.navigation.popToTop();
                props.navigation.replace(ScreenRoute.home)
                windowGTagEvent({ 'send_to': 'AW-713052563/nx4sCJeqwOMCEJOjgdQC', 'value': getSalesPrice(servicePricingData.servicePricing), 'currency': 'INR' })
            }
        } else {
            if (isConsultationService(serviceType.serviceName) === true) {
                MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.econsult_payment_cancelled)
            }

            if (isConsultationService(serviceType.serviceName) === false ||
                (checkPayVia(serviceType.payVia) === false && isConsultationService(serviceType.serviceName) === true)) {
                MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_payment_cancelled)
            }
        }

    }

    function onPaymentCompletion(data) {
        updateScreenState({ loader: true })
        var paymentCBData = JSON.parse(data);
        paymentCBData['signedPaymentToken'] = staticData['signedPaymentToken'];
        doPost('payment/complete_wallet_recharge', paymentCBData).
            then((response) => {
                updateScreenState({ loader: false });
                if (response) {
                    if (isConsultationService(serviceType.serviceName) === false) {
                        MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_purchased)
                    }

                    updateFBQData('completion');
                    // TODO: handle post payment redirection.
                    if (isConsultationService(serviceType.serviceName)) {
                        props.navigation.navigate(ScreenRoute.econsult_success);
                        windowGTagEvent({ 'send_to': 'AW-713052563/TxuvCPag6OMCEJOjgdQC', 'transaction_id': '' })
                    } else {
                        const reduxState = store.getState();
                        let refreshList = [{
                            name: RefreshCacheAction.refreshUserProfileData,
                            requestData: { pharmacyId: getSelectedChemistStoreId(reduxState) }
                        }]
                        CacheDataToRefresh.setRefreshList(refreshList)
                        props.navigation.popToTop();
                        props.navigation.replace(ScreenRoute.home)
                        windowGTagEvent({ 'send_to': 'AW-713052563/nx4sCJeqwOMCEJOjgdQC', 'value': getSalesPrice(servicePricingData.servicePricing), 'currency': 'INR' })
                    }
                } else {
                    if (isConsultationService(serviceType.serviceName) === true) {
                        MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.econsult_payment_cancelled)
                    } else if (checkPayVia(serviceType.payVia) === false &&
                        isConsultationService(serviceType.serviceName))
                        MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_payment_cancelled)

                    setToastData({ showToast: true, text: 'Your payment is failed!' })
                }
            }, (error: any) => {
                updateScreenState({ loader: false });
                setToastData({ showToast: true, text: getToastContent(error['msg']) })
            }
            );
    }

    function startEConsultWalletPayment(userId, serviceToken) {
        updateScreenState({ loader: true });
        const params = {
            'userId': userId,
            'serviceTokenV2': serviceToken
        }; doPost('payment/complete_consultation_payment', params).then(
            (response) => {
                updateScreenState({ loader: false });
                updateFBQData('completion');
                // props.navigation.popToTop();
                // global.navigateFrom = NavigateFrom.econsult_success
                // props.navigation.replace(ScreenRoute.dashboard);
                props.navigation.navigate(ScreenRoute.econsult_success);
            }, (error) => {
                updateScreenState({ loader: false });
                setToastData({ showToast: true, text: getToastContent(error['msg']) })
            }
        )
    }

    function startAayuCardwalletPayment(userId, serviceToken) {
        updateScreenState({ loader: true });
        const params = {
            'userId': userId,
            'serviceTokenV2': serviceToken
        }; doPost('payment/complete_aayu_subscription_payment', params).then(() => {
            updateScreenState({ loader: false });
            MoengageUtils.trackMoengageEvents(MoengageUtils.MoengageEvents.aayu_card_purchased)
            updateFBQData('completion');
            if (isConsultationService(serviceType.serviceName)) {
                props.navigation.navigate(ScreenRoute.econsult_success);
            } else {
                let refreshList = [{
                    name: RefreshCacheAction.refreshUserProfileData,
                    requestData: {skipMeoUpdate: true}
                }]
                CacheDataToRefresh.setRefreshList(refreshList)
                props.navigation.popToTop();
                props.navigation.replace(ScreenRoute.dashboard_screen)
            }
        }, (error: any) => {
            updateScreenState({ loader: false });
            setToastData({ showToast: true, text: getToastContent(error['msg']) })
        }
        );
    }

    function couponCodePopUp() {
        return <Modal backdropOpacity={0.70} deviceHeight={AppTheme.appHeight} style={{ margin: 'auto', flex: 1, height: window.innerHeight }}
            animationOut={'slideOutDown'} animationOutTiming={1000}
            isVisible={couponPopUp.showPopup}>
            <View style={[AppStyles.modalContainer]}>
                <Image source={{
                    uri: CommonUtils.getImagePath('/images/icons/pop_up_applied.svg'),
                    height: 71, width: 110
                }} style={{ marginTop: 12 }} />
                <Text style={[TextStyle.text12, { paddingTop: 48 }]}>
                    <b>{couponPopUp.couponCode}</b> {couponPopUp.titleString}</Text>
                {couponPopUp.valid && <Text style={[TextStyle.text20b, { paddingTop: 8 }]}>
                    {couponPopUp.subTitle}</Text>}
                {couponPopUp.valid && <Text style={[TextStyle.text12, { color: AppTheme.color.grey.text, paddingTop: 8 }]}>
                    with this coupon</Text>}
                <View style={{
                    width: AppTheme.appWidth - 120, height: 1,
                    backgroundColor: AppTheme.color.grey.divider, marginVertical: 16
                }} />
                <Pressable style={{ marginVertical: 6 }}
                    onPress={() => { setCouponPopup({ showPopup: false }) }}>
                    <Text style={[TextStyle.text18b, {
                        color: AppTheme.color.primary
                    }]}>Great</Text></Pressable>
            </View>
        </Modal>
    }

    const setCouponPopup = (modalData) => {
        if (modalData.showPopup) {
            updateCouponPopUp(modalData)
        } else {
            updateCouponPopUp({
                showPopup: false, valid: couponPopUp.valid,
                couponCode: '', titleString: '', subTitle: ''
            })
        }
    }

    const showSurveyBottomSheet = () => {
        setSurveyBottomSheet(true)
    }

    const closeSurveyBottomSheet = () => {
        setSurveyBottomSheet(false)
    }

    useEffect(() => {
        if (Object.keys(props.route.params?.serviceParams).length != 0) {
            checkSelectedAayuCardData();
        }

    }, [])

    function getbackServiceChargeCB(copCode) {
        updateCouponText(copCode);
        setServiceParams(copCode);
    }

    return (
        <View style={[AppStyles.appBg, { height: window.innerHeight }]}>

            {AlertService.loaderModal.setLoader(screen.loader && render, 0.6)}

            <CommonHeader handleBackPress={showSurveyBottomSheet}
                title={props.route?.params?.serviceName === ServiceName.consultation ?
                    'Remote Consultation' : 'Aayu Card Payment'} />

            {render ? <KeyboardAvoidingView style={[{
                marginTop: AppTheme.headerHeight,
                minHeight: window.innerHeight - AppTheme.headerHeight
            }]}>{isValidService ? <View>

                <ScrollView style={[AppStyles.mx16, { marginBottom: 145 }]}>

                    {
                        isConsultationService(serviceType.serviceName) ?
                            <View style={[AppStyles.flexRowCenter, { justifyContent: "space-between", marginTop: 8 }]}>
                                <View>
                                    <Text style={{ fontSize: 16, marginBottom: 4, color: AppTheme.color.black }}>{props.route.params.serviceParams.memberName}</Text>
                                    <Text style={{ fontSize: 16, fontWeight: '600' }}>E-Consult for <Text style={{ color: AppTheme.color.green.primary }}>
                                        {checkCaseCodeLength(props.route.params.serviceParams.category)}</Text></Text>
                                </View>
                                <Avatar source={{ uri: getCategoryImageNetworkURL(props.route.params.serviceParams.caseCode) }}
                                    size={60} avatarStyle={{ borderRadius: 150, margin: 6, shadowRadius: 4, shadowOpacity: 0.3 }} />
                            </View> : <View style={{ marginTop: 24, marginHorizontal: 14, shadowOpacity: 0.4, shadowRadius: 8, borderRadius: 4, borderWidth: 2, borderColor: AppTheme.color.white }}>
                                <AayuCardDesign aayuCardPlan={serviceData.data} margin={32} /></View>
                    }

                    <View style={{ marginVertical: 16 }}>
                        <Pressable onPress={() => {
                            couponText.length == 0 ?
                                props.navigation.navigate(ScreenRoute.oms_offers, {
                                    getbackServiceChargeCB: getbackServiceChargeCB, offersList: omsOffers
                                }) : null
                        }} style={[AppStyles.lightShadow, { borderRadius: 12, paddingHorizontal: 16, paddingVertical: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                            <View style={AppStyles.flexRowSpaceBetween}>
                                <Image source={{ uri: CommonUtils.getImagePath(`/images/oms/rops/${couponText.length > 0 ? 'offers_comps_applied' : 'offers_comps'}.svg`), width: 24, height: 24 }}
                                    style={{ width: 24, height: 24 }} />
                                <View style={{ flexGrow: 1, paddingLeft: 7 }}>
                                    <Text style={[TextStyle.text16b, OmsStyles.commonTextColor]}>
                                        {couponText.length > 0 ? `Code ${couponText} applied!` : 'View all promo codes'}</Text>
                                </View>
                                <Pressable onPress={() => {
                                    updateCouponText('')
                                    // keyboard dismiss for popup loder overlay
                                    Keyboard.dismiss();
                                    setTimeout(() => { setServiceParams('', serviceType.payVia) }, 50)
                                }}>
                                    <Image resizeMode='contain' source={{ uri: CommonUtils.getImagePath(`/images/${couponText.length > 0 ? 'icons/cancel.svg' : 'oms/rops/blue-right-chev.svg'}`), width: couponText.length > 0 ? 18 : 6, height: couponText.length > 0 ? 18 : 10 }} />
                                </Pressable>
                            </View>
                            {showPromoNotApplicableMessg ? <Text style={[TextStyle.text12xb, { color: 'red', paddingLeft: 32, position: 'relative', top: 2 }]}>Invalid coupon code</Text> : null}
                        </Pressable>

                    </View>


                    <View style={[styles.invoiceCard, AppStyles.lightShadow]}>
                        <Text style={styles.yourInvoice}>YOUR INVOICE</Text>
                        <View style={styles.invoiceInfo}>
                            <Text style={styles.invoiceText}>
                                {
                                    isConsultationService(serviceType.serviceName) && checkPayVia(serviceType.payVia) ?
                                        ' Doctor\'s Fee' : ' Aayu Card Price'
                                }
                            </Text>
                            <Text style={styles.invoiceText}>{IndiaRupee} {getSalesPrice(servicePricingData.servicePricing)}</Text>
                        </View>

                        <View style={styles.invoiceInfo}>
                            <Text style={styles.invoiceText}> Aayu Cash</Text>
                            <Text style={styles.invoiceText}>-{IndiaRupee} {parseInt(getWalletUsableBalance(servicePricingData.servicePricing))?.toFixed(0)}</Text>
                        </View>

                        {getSehatSikke(servicePricingData.servicePricing) > 0 && <View style={styles.invoiceInfo}>
                            <Text style={styles.invoiceText}> Sehat Sikke </Text>
                            <Text style={styles.invoiceText}>-{IndiaRupee} {getSehatSikke(servicePricingData.servicePricing)}</Text>
                        </View>}

                        {getDiscountPrice(servicePricingData.servicePricing) > 0 && <View style={styles.invoiceInfo}>
                            <Text style={styles.invoiceText}> Coupon Discount </Text>
                            <Text style={styles.invoiceText}>-{IndiaRupee} {getDiscountPrice(servicePricingData.servicePricing)}</Text>
                        </View>}

                        {getTotalSavings(servicePricingData.servicePricing) > 0 && <View style={[styles.invoiceInfo, {
                            marginHorizontal: 8, marginTop: 15, justifyContent: "center",
                            backgroundColor: AppTheme.color.green.lightPrimary,
                            borderWidth: 2, borderColor: AppTheme.color.green.primary, borderStyle: "dashed"
                        }]}>
                            <Text style={[styles.invoiceText, { color: AppTheme.color.green.primary }]}>
                                You have saved {IndiaRupee} {getTotalSavings(servicePricingData.servicePricing)}
                                {isConsultationService(serviceType.serviceName) ?
                                    ' on this consultation' : ''}</Text>
                        </View>}

                        {isConsultationService(serviceType.serviceName) ? <TouchableOpacity onPress={() => {
                            setEConsultAayuCardParams(checkPayVia(serviceType.payVia))
                        }}
                            style={{ alignContent: "center", alignItems: "center", backgroundColor: AppTheme.color.green.primary, marginHorizontal: 8, paddingVertical: 8, shadowRadius: 4, shadowOpacity: 0.3 }}>
                            {checkPayVia(serviceType.payVia) ? <Text style={[styles.invoiceText, { color: AppTheme.color.white }]}>
                                Do you want to save more? Click now
                                {getCircularIcon("arrow-upward")}</Text> : <Text style={[styles.invoiceText, { color: AppTheme.color.white }]}>
                                Great decision! {selectedEConsultAayuCard['consultations']} consults plan selected {getCircularIcon("clear")}</Text>}
                        </TouchableOpacity> : <View />}

                        <View style={[styles.invoiceInfo, { padding: 8, marginVertical: 16 }]}>
                            <Text style={[styles.invoiceText, { fontWeight: '600', fontSize: 16 }]}>
                                To Pay
                            </Text>
                            <Text style={[styles.invoiceText, { fontWeight: '600', fontSize: 16 }]}>
                                {IndiaRupee} {getTotalPay(servicePricingData.servicePricing)}</Text>
                        </View>
                    </View>
                </ScrollView>

                <View style={[AppStyles.bottomFix, { shadowRadius: 1, shadowOpacity: 1 }]}>
                    <PrimaryCTA marginVertical={24}
                        text={`PAY NOW ${IndiaRupee} ${getTotalPay(servicePricingData.servicePricing)}`}
                        onPress={() => {
                            updateFBQData('initialize');
                            updateEConsultInfo();
                            checkPaymentMode()
                        }} />

                    <View style={[AppStyles.flexRowCenter, { marginBottom: 20, marginHorizontal: 16, }]}>

                        <Text style={styles.dontWorry}>
                            <Image style={{ padding: 5, width: 12, height: 12 }}
                                source={{
                                    uri: CommonUtils.getImagePath('/images/secure_payment_ic.svg'),
                                    width: 12.3, height: 14
                                }} ></Image> Don't worry, this payment is completely safe</Text>
                    </View>

                </View>

            </View> : <View></View>}
            </KeyboardAvoidingView > : <View style={{ marginTop: AppTheme.headerHeight }}>
                <ScreenShimmer.PaymentShimmer /></View>
            }

            {couponCodePopUp()}

            <SingleOptionSelectionBottomSheet
                showModal={surveyBottomSheet}
                modalTitle={isConsultationService(serviceType.serviceName) ?
                    'Let\'s know what problem you faced?' :
                    'What problem did you face during the Aayu card purchase?'}
                optionsList={isConsultationService(serviceType.serviceName) ?
                    consultationPaymentSurveyList : aayuCardPaymentbackSurveyList}
                closeModal={closeSurveyBottomSheet}
                primaryAction={submitPaymentCancellationReason} />

            <ToastModal showToast={toastData['showToast']}
                setToast={(toastData: any) => { setToastData(toastData) }}
                text={toastData['text']} />

        </View >
    )
}

export default ServicePayment;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({

    view: {
        justifyContent: 'flex-end',
        margin: 0,
    },
    submit: {
        marginBottom: 10, paddingVertical: 15,
        backgroundColor: AppTheme.color.blue.cta, borderRadius: 4, borderWidth: 1, borderColor: '#fff'
    },
    submitText: {
        color: '#fff',
        textAlign: 'center',
    },
    dontWorry: { fontSize: 14, paddingTop: 3, color: AppTheme.color.grey.disable },
    yourInvoice: { color: AppTheme.color.primary, fontSize: 14, padding: 10 },
    planHead: {
        flex: 1,
        justifyContent: 'flex-start',
        backgroundColor: '#cce6ff',
        flexDirection: 'row',
        padding: 10,
        marginVertical: 16,
        alignContent: 'center',
        textAlign: 'center',
        alignItems: "center",
        borderWidth: 0.5,
        borderColor: '#9cd500',
        borderRadius: 4
    },
    consultIcon: {
        width: 24,
        height: 24,
        borderRadius: 50,
        justifyContent: 'center',
        alignContent: "center",
        alignItems: 'center'
    },
    consulText: {
        fontSize: 14,
        color: '#000000',
        paddingLeft: 10
    },
    cardHead: {
        flex: 1,
        justifyContent: 'flex-start',
        flexDirection: 'row',
        padding: 10,
        borderRadius: 4,
        alignContent: "center",
        alignItems: 'center'
    },
    arrowExpand: {
        width: 50,
        alignContent: "center",
        alignItems: 'center'
    },
    cardInfo: {
        flex: 1,
        justifyContent: 'flex-start',
        color: '#fff',
        flexDirection: 'row',
        fontSize: 12,
        padding: 6
    },
    checkMark: {
        width: 20,
        color: '#fff'
    },
    infoText: {
        color: '#fff',
        fontSize: 12,
        width: 250
    },

    invoiceCard: {
        marginVertical: 4,
        borderRadius: 4,
        marginHorizontal: 2,
        // padding: 16,
        shadowColor: AppTheme.color.lightGreyColor,
        zIndex: 3,
    },
    invoiceText: {
        color: '#5f5f5f',
        fontSize: 14
    },

    invoiceInfo: {
        flex: 1,
        justifyContent: 'space-between',
        flexDirection: 'row',
        padding: 6,
        paddingHorizontal: 16
    },
    searchInput: {
        height: 44,
        padding: 8,
        flex: 1,
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        alingItem: "center",
        textAlign: "center",
        backgroundColor: AppTheme.color.background,
        shadowColor: AppTheme.color.lightGreyColor,
        zIndex: 1, shadowOpacity: 0.2, shadowRadius: 4, shadowOffset: {
            height: 1.4,
            width: 1.4
        }
    },
    discountIcon: {
        // paddingLeft: 10,
        marginRight: 6,
        lineHeight: 30,
        position: 'relative',
        marginTop: 4,
        tintColor: AppTheme.color.black
    },
    inputBox: {
        width: AppTheme.appWidth - 50,
        // marginTop: 2,
        fontSize: 16,
        fontWeight: '400',
        alignContent: "center",
        alignItems: "center",
        paddingLeft: 5,
        fontFamily: 'normal'
    },
    arrowIcon: {
        alignContent: "center",
        // marginHorizontal: 8
    },
    safePayment: {
        flex: 1,
        justifyContent: 'flex-start',
        flexDirection: 'row',
        alignContent: 'center',
        textAlign: 'center',
    }
}))
